import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { Select } from 'antd';
import { text_companyNm } from 'lib/textChang';
import { COMPANY_TYPE } from 'constant';

@inject('commonStore')
@observer
class CenterOptionList extends Component {

  UNSAFE_componentWillMount() {
    this.props.commonStore.disBranchOption();
  }

  render() {
    const {
      branchOption,
      disCenterOption,
      centerOption,
      
      sessionLoginInfo,
    } = this.props.commonStore;
    const {
      onlyBranchCd, branchCdDisabled,
      ceBranchCdValue, ceCdValue, eBranchCdChange, ceCdfuncChange,
      allText
    } = this.props;

    const centerOptionOrder = () =>{ return (
      branchOption.map((item)=>{
        let itemNm = item?.ceNm || '';
        if(sessionLoginInfo?.cGbn === COMPANY_TYPE.BENZ) {
          const sliceIdx = itemNm.indexOf('(');
          if(sliceIdx > 0 && itemNm.indexOf(')') > 0){
            itemNm = (itemNm.slice(0, sliceIdx))
          }
        }
        return <Select.Option key={item.ceCd}>{itemNm}</Select.Option>
      })
    )}

    return (
      sessionLoginInfo?.cGbn && 
      // 상위 셀렉트박스만 사용할지 여부 
      (onlyBranchCd === true)
      ? <Fragment>
          <Select 
            disabled={branchCdDisabled}
            style={{width: 230, marginRight: '20px'}}
            value={ceBranchCdValue}
            onChange={(value, option)=>{
              eBranchCdChange && eBranchCdChange(value, option);
            }}
          >
            <Select.Option key={""}>{allText || "선택해주세요."}</Select.Option>
            {centerOptionOrder()}
          </Select>
        </Fragment>
      : <Fragment>
          <span className="mo_srch">
            <span className="labal2">{text_companyNm()}</span>
            <Select
              style={{width: 230, marginRight: '20px'}}
              value={ceBranchCdValue}
              onChange={(value)=>{
                disCenterOption(value);
                eBranchCdChange && eBranchCdChange(value);
              }}
            >
              <Select.Option key={""}>전체</Select.Option>
              {centerOptionOrder()}
            </Select>
          </span>
          <span className="mo_srch">
            <span className="labal2">센터</span>
            <Select
              disabled={ceBranchCdValue==='' ? true : false}
              style={{ width: 150, marginRight: '20px' }}
              value={ceCdValue}
              onChange={(value)=>{
                ceCdfuncChange && ceCdfuncChange(value);
              }}
            >
              <Select.Option key={""}>전체</Select.Option>
              {centerOption.map(item=>
                <Select.Option key={item.ceCd}>{item.ceNm}</Select.Option>)}
            </Select>
          </span>
        </Fragment>
    );
  }

}

export default CenterOptionList;
